

import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { FreeShipMethodID, DefaultShipMethodID, FlatRateShipMethodID, DefaultCountry } from 'src/app/constant';
import { ConfigService } from './config.service';

@Injectable({
    providedIn: 'root'
})
export class ShippingMethodService {

    constructor(public configService: ConfigService) {}

    /**
     * Determines the shipping method ID based on various conditions
     * @param orderSubtotal - The order subtotal amount
     * @param customerType - Customer type (1=IBO/Enrolled, 2=Retail, 3=Autoship)
     * @param isAutoShip - Whether this is an autoship order
     * @param rewardPointsUsed - Amount of reward points used (default: 0)
     * @param isFirstOrder - Whether this is the customer's first order (default: false)
     * @returns The shipping method ID string
     */
    getShippingMethodId(orderSubtotal: number, customerType: number, isAutoShip: boolean, rewardPointsUsed: number = 0, isFirstOrder: boolean = false): string {
        const selectedCountry = this.configService.commonData.selectedCountry || DefaultCountry;
        const shippingData = this.configService.commonData?.CountryCode?.[selectedCountry];
        const shippingMethodId = shippingData?.ShippingMethod || DefaultShipMethodID;
        const today = new Date();
        const dayOfMonth = today.getDate();

        // Calculate the actual amount being paid (subtotal minus reward points)
        const actualAmountPaid = Math.max(0, orderSubtotal - rewardPointsUsed);

        // Countries excluded from free shipping: Canada (CA), Australia (AU), New Zealand (NZ)
        const excludedCountries = ['CA', 'AU', 'NZ'];
        const isExcludedCountry = excludedCountries.includes(selectedCountry?.toUpperCase());

        // Only apply free shipping rules if not in excluded countries (US only for first order rule)
        if (!isExcludedCountry) {
            // First order free shipping - applies to all customer types in US only
            if (isFirstOrder) {
                return FreeShipMethodID;
            }

            // Existing rules for customer types 1, 2, or 3
            if (customerType === 1 || customerType === 2 || customerType === 3) {
                if ((isAutoShip && dayOfMonth >= 1 && dayOfMonth <= 5) && customerType !== 3) {
                    return FreeShipMethodID;
                }
                if(isAutoShip && (customerType === 3 || customerType === 2)){
                    return FreeShipMethodID;
                }
                // Free shipping based on actual amount being paid (not just subtotal)
                if (actualAmountPaid >= 145) {
                    return FreeShipMethodID;
                }
            }
        }
        return shippingMethodId;
    }

    /**
     * Checks if the current country is eligible for free shipping
     * @returns boolean indicating if free shipping is available for this country
     */
    isFreeShippingEligibleCountry(): boolean {
        const selectedCountry = this.configService.commonData.selectedCountry || DefaultCountry;
        const excludedCountries = ['CA', 'AU', 'NZ'];
        return !excludedCountries.includes(selectedCountry?.toUpperCase());
    }
}